import { Grid } from '@mui/material';
import React from 'react';
import HeaderTitle from '../UI/header/HeaderTitle';

import UsersTableInfo from '../proband-info/UsersTableInfo';

function PatientProband() {
  return (
    <Grid container>
      <HeaderTitle text={'Your Family History'} />
      <Grid size={12}>
        <br></br>
        <UsersTableInfo patient={true} />
      </Grid>
    </Grid>
  );
}

export default PatientProband;
